import { createFileRoute } from '@tanstack/react-router'

import { SuggestionPassSettings } from '@/components/Internal/System/SuggestionPassSettings'

export const Route = createFileRoute('/internal/system/operations/suggestions')(
  {
    component: SuggestionPassSettings,
  },
)
